export const spectacleFramesFlow = {
  steps: [
    { id: "gender", type: "single", question: "Select Gender", dataKey: "all_gender", stepLabel: "1/05", filterKey: "gender" },
    { id: "material", type: "single", question: "Select Material you are looking for", dataKey: "all_material", stepLabel: "2/05", filterKey: "material" },
    { id: "frameType", type: "single", question: "Select the Frame Type you are looking for", dataKey: "all_frame_type", stepLabel: "3/05" },
    { id: "colour", type: "single", question: "Select the Frame Colour you prefer", dataKey: "all_color", stepLabel: "4/05", filterKey: "colour" },
    { id: "shape", type: "single", question: "Select the Frame Shape you are looking for", dataKey: "all_shape", stepLabel: "5/05", filterKey: "frameShape" },
  ],
  onComplete: "showPopup",
};